export const MANUAL_TOKEN_KEY = 'amia_manual_token';
